import React, { useEffect, useMemo } from 'react';

// Router
import Router from './routes';

// Component
import AuthProvider from '@contexts/Auth/AuthProvider';
import ScrollToTop from '@components/ScrollToTop';
import { SettingsProvider } from '@contexts/Setting/SettingsContext';
import Theme from '@theme/Theme';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactNotifications } from 'react-notifications-component';
import ChatBot from '@components/ChatBot/ChatBot';
import { ConfigProvider } from 'antd';
import { getAntdTheme } from '@theme/modernAntdTheme';
import { ThemeModeProvider, useThemeMode } from '@contexts/ThemeMode/ThemeModeContext';
import 'react-notifications-component/dist/theme.css';
import 'react-image-gallery/styles/css/image-gallery.css';
import 'assets/css/override.css';
import 'assets/css/modern.css';
import 'swiper/css';
import 'swiper/css/navigation';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      cacheTime: 0
    }
  }
});

// antd theme follows the light/dark mode. Static APIs (Modal.confirm, message) render
// outside the React tree, so they get the same theme via holderRender.
const AntdThemeProvider = ({ children }) => {
  const { mode } = useThemeMode();
  const antdTheme = useMemo(() => getAntdTheme(mode), [mode]);

  useEffect(() => {
    ConfigProvider.config({
      holderRender: (node) => <ConfigProvider theme={antdTheme}>{node}</ConfigProvider>
    });
  }, [antdTheme]);

  return <ConfigProvider theme={antdTheme}>{children}</ConfigProvider>;
};

function App() {
  return (
    <ThemeModeProvider>
      <AntdThemeProvider>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            <ScrollToTop />
            <SettingsProvider>
              <Theme>
                <ReactNotifications />
                <Router />
                <ChatBot />
              </Theme>
            </SettingsProvider>
          </QueryClientProvider>
        </AuthProvider>
      </AntdThemeProvider>
    </ThemeModeProvider>
  );
}

export default App;
